<div class="outer-container">
    <div class="workspace-container">
        <button class="cancel-btn" (click)="handleCancel()">
            <img src="assets/24x24/arrow-left-circle.svg" alt="">
            <span>Back</span>
        </button>
        <div class="workspace-details-container">
            <app-loader class="loader" *ngIf="loaderView"></app-loader>
            <ng-container *ngIf="!loaderView">
                <section class=" workspace-primary-details">
                    <div class="workspace-name-id">
                        <div class="workspace-name">
                            {{workspaceDetails?.name | titlecase}}
                        </div>
                    </div>
                    <div class="workspace">
                        <div class="heading-and-edit">
                            <div class="profile">Workspace Details</div>
                            <app-button theme="secondary" size="xsmall" (click)="handleEdit('workspaceDetails')">Edit Workspace</app-button>
                        </div>
                        <div class="workspace-info">
                            <div class="title">Creator Details</div>
                            <div class="workspace-details">
                                <div class="frame1">
                                    <div class="label">
                                        <span class="head">Workspace Created By</span><span>:</span><span class="name">
                                            {{(workspaceDetails?.createdByUser) ? workspaceDetails?.createdByUser?.firstName + " " +
                                            workspaceDetails?.createdByUser?.lastName : 'N/A'}}
                                        </span>
                                    </div>
                                    <div class="label">
                                        <span class="head">Email</span><span>:</span>
                                        <span class="email">
                                            {{ (workspaceDetails?.createdByUser) ?  workspaceDetails?.createdByUser?.email : 'N/A' }}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="workspace-info">
                            <div class="title">Company Details</div>
                            <div class="workspace-details">
                                <div class="frame1">
                                    <div class="label">
                                        <span class="head">Company Name</span><span>:</span>
                                        <span class="name">
                                            {{workspaceDetails?.companyName}}
                                        </span>
                                    </div>
                                    <div class="label">
                                        <span class="head">Company Link</span><span>:</span>
                                        <span class="website-link" >
                                            <a [href]="workspaceDetails?.companyWebsiteLink" target="_blank">
                                                {{workspaceDetails?.companyWebsiteLink!.includes('www') 
                                                ? workspaceDetails?.companyWebsiteLink!.split('//')[1]
                                                : 'www.' + (workspaceDetails!.companyWebsiteLink!.split('//')[1])}}
                                            </a>
                                        </span>
                                    </div>
                                    <div class="label">
                                        <span class="head">Establishment Date</span><span>:</span>
                                        <span class="website-link">
                                            {{workspaceDetails?.createdAt?.split('T')![0]}}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="workspace-info">
                            <div class="title">Acronyms</div>
                            <div class="workspace-details">
                                <div class="label">
                                    <span>Acronym</span><span>:</span>
                                    <span>{{getAcronyms(workspaceDetails?.acronyms)}}</span>
                                </div>
                            </div>
                        </div>
                        <div class="workspace-small-details">
                            <div class="workspace-info">
                                <div class="title">Allowed Domains</div>
                                <div class="workspace-details">
                                    <div class="label">
                                        <span>Domains</span><span>:</span>
                                        <span>{{workspaceDetails?.workspace_auth?.allowedDomains![0]}}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="workspace-info">
                                <div class="title">Selected Login</div>
                                <div class="workspace-details">
                                    <div class="label">
                                        <span>Sign In Method</span><span>:</span>
                                        <span>{{workspaceDetails?.workspace_auth?.auth_type?.name}}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="workspace-info">
                                <div class="title">Location</div>
                                <div class="workspace-details">
                                    <div class="label">
                                        <span>Location</span><span>:</span>
                                        <span>{{workspaceDetails?.locations![0]}}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="workspace">
                        <div class="heading-and-edit">
                            <div class="profile">User Attributes</div>
                            <app-button theme="secondary" size="xsmall" (click)="handleEdit('userAttributes')">Add Attributes</app-button>
                        </div>
                        <div class="company-details">
                            <div>
                                <div class="field">
                                    <span class="head">Employee Type</span><span>:</span>
                                    <span class="name">
                                        {{ getAttributeValues('empType') || 'N/A'}}
                                    </span>
                                    <!-- <span>
                                        <button class="edit-button" (click)="onEditConfig('Employee Type',0)">
                                            <img src="assets/14x14/edit_blue.svg" alt="Edit" class="edit-icon">
                                        </button>
                                    </span> -->
                                </div>
                                <div class="field">
                                    <span class="head">Employee Status</span><span>:</span>
                                    <span class="website-link">
                                        {{getAttributeValues('empStatus') || 'N/A'}}
                                    </span>
                                    <!-- <span>
                                        <button class="edit-button" (click)="onEditConfig('Employee Status',0)">
                                            <img src="assets/14x14/edit_blue.svg" alt="Edit" class="edit-icon">
                                        </button>
                                    </span> -->
                                </div>
                                <div class="field">
                                    <span class="head">Designation</span><span>:</span>
                                    <span class="website-link">
                                        {{getAttributeValues('designation') || 'N/A'}}
                                    </span>
                                    <!-- <span>
                                        <button class="edit-button" (click)="onEditConfig('Employee Designation',0)">
                                            <img src="assets/14x14/edit_blue.svg" alt="Edit" class="edit-icon">
                                        </button>
                                    </span> -->
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="heading-and-edit-owner profile-details" *ngIf="(workspaceDetails?.workspaceOwnerCount! > 0) && (workspaceDetails?.workspaceOwner)">
                            <div class="profile">Owner Details</div>
                            <app-button theme="secondary" size="xsmall" (click)="handleEdit('workspaceOwnerDetails')" *ngIf="workspaceDetails?.workspaceOwnerCount! <= 0">Add Workspace Owner</app-button>
                    </div>
                    <ng-container *ngIf="(workspaceDetails?.workspaceOwnerCount! > 0) && (workspaceDetails?.workspaceOwner)">
                    <div class="workspace">
                        <div class="workspace-info">
                            <div class="workspace-details">
                                <div class="frame1">
                                    <div class="label">
                                        <span class="head">Owner Name</span><span>:</span><span class="name">
                                            {{workspaceDetails?.workspaceOwner?.firstName + " " +
                                            workspaceDetails?.workspaceOwner?.lastName}}
                                        </span>
                                    </div>
                                    <div class="label">
                                        <span class="head">Email</span><span>:</span>
                                        <span class="email">
                                            {{workspaceDetails?.workspaceOwner?.email}}
                                        </span>
                                    </div>
                                </div>
                                <div class="frame2">
                                    <div class="label">
                                        <span class="head">Employee Id</span><span>:</span>
                                        <span class="email">
                                            {{workspaceDetails?.workspaceOwner?.employeeId}}
                                        </span>
                                    </div>
                                    <div class="label">
                                        <span class="head">Phone</span><span>:</span>
                                        <span class="email">
                                            {{workspaceDetails?.workspaceOwner?.phoneNumber}}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    </ng-container>
                </section>
                <section class="right-section">
                <div class="outer-circle">
                    <div class="workspace-initial">
                        <span class="initial-circle">
                            {{ workspaceDetails?.name?.charAt(0) || "-" }}
                        </span>
                    </div>
                </div>
                <ng-container *ngIf="workspaceDetails?.plan?.length===0">
                        <div class="button-container">
                            <app-button theme="primary" size="xsmall" (click)="handleEdit('plan')">Add Plan</app-button>
                        </div>
                    </ng-container>
                </section>
            </ng-container>
        </div>
    </div>
</div>